type Listener = () => void;

export interface LastRequestInfo {
  method: string;
  path: string;
  status: number | "network";
  ms: number;
  errorId?: string;
  at: number;
}

let last: LastRequestInfo | null = null;
const listeners = new Set<Listener>();

export function recordLastRequest(info: LastRequestInfo): void {
  last = info;
  for (const l of listeners) l();
}

export function getLastRequest(): LastRequestInfo | null {
  return last;
}

export function subscribeLastRequest(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
